import "./App.css";
import Weather from "./weather";

function App() {
  return (
    <div className="App">
      <Weather defaultCity="Pretoria" />
    </div>
  );
}

export default App;